/* eslint-disable react/jsx-props-no-spreading */
import React, { } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { useTranslation } from 'react-i18next';

// icon
import { RadarIcon } from '../../assets/svg/Icon';

// components
import RadarDataLists from './lists/RadarDataLists';

// style
import { globalStyle } from '../../global/style';

const useStyles = makeStyles(globalStyle);

export default function Main() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <RadarIcon style={{ color: 'white' }} />
            </Box>
            <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('เรดาร์')}</Typography></Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs>
          <RadarDataLists />
        </Grid>
      </Grid>
    </div>
  );
}
